import React from "react";
import { useTable, useSortBy } from "react-table";
import { formatDate } from "../../../Utility";

function MaintenanceHistory({ allMaintenances, setShowMaintainceHistory }) {
  const columns = React.useMemo(
    () => [
      {
        Header: "Type maintenance",
        accessor: "maintanance_type_name",
      },

      {
        Header: "Date",
        accessor: (row) => formatDate(row?.date),
      },
      {
        Header: "Description",
        accessor: "message",
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data: allMaintenances,
    },
    useSortBy
  );

  return (
    <div>
      <div
        className="d-flex align-items-center fw-bold cursor-pointer mb-2"
        onClick={() => setShowMaintainceHistory(false)}
      >
        <img src={require("../../../assets/images/arrow-left.svg").default} />
        <span style={{ marginLeft: "10px" }}>Back</span>
      </div>

      <div className="row">
        <div className="col-xl-5 col-lg-4">
          <div className="page-title">
            <h3>Maintenance History</h3>
          </div>
        </div>
      </div>
      {rows.length > 0 ? (
        <div className="table-responsive">
          <table {...getTableProps()} className="table customise-table cell-border w-100">
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                      {column.render("Header")}
                      <span style={{ color: "#8C8C8C", marginLeft: "12px" }}>
                        {column.isSorted ? (
                          column.isSortedDesc ? (
                            <i className="fa fa-caret-down"></i>
                          ) : (
                            <i className="fa fa-caret-up"></i>
                          )
                        ) : (
                          ""
                        )}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="no-data-found text-center">
          <p>So far, you have not had any maintenance requests.</p>
        </div>
      )}
    </div>
  );
}

export default MaintenanceHistory;
